import {OnlinePaymentTypeEnum} from '@/services/api-clients';
export function onlinePaymentTypeLogoFilter(type: OnlinePaymentTypeEnum): [any, number, number] {

  switch (type) {
    case OnlinePaymentTypeEnum.PayU: return [require('@/assets/online-payments/payu.svg'), 1134, 1134]
  }
}
